export const WALLET_FUND_REFERENCE_KEY = 'madina_wallet_fund_reference';

export const readWalletFundPayload = (body: any) => {
  const payload = body?.data ?? body ?? {};
  return {
    funded: payload.funded === true,
    balance: payload.balance,
    message: body?.message || payload.message
  };
};
